import { render, staticRenderFns } from "./FormBuilderPalette.vue?vue&type=template&id=0bd6ec61&scoped=true&lang=pug&"
import script from "./FormBuilderPalette.vue?vue&type=script&lang=js&"
export * from "./FormBuilderPalette.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderPalette.vue?vue&type=style&index=0&id=0bd6ec61&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd6ec61",
  null
  
)

/* custom blocks */
import block0 from "./FormBuilderPalette.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports